import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {Link} from 'react-router-dom';
import _HomeBanner from './_HomeBanner.scss';
import TradeNewsContainer from './TradeNewsContainer.jsx';
import HighlightPromotions from './HighlightPromotions.jsx';
import HighlightVideo from './HighlightVideo.jsx';
import {HomeCategoryMenu} from 'components/category';
import {HighlightNeedOfferTab, TopBusinessTab, TopProductTab} from 'components/home/sub-view';
import ReactDOM from 'react-dom';
import Slider from 'slider';
import {HomeBanners} from 'base/api';
import {connect} from 'react-redux';
import CONFIG from 'base/constants/config';

class HomeBanner extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.loadHomeBannersFromServer = this.loadHomeBannersFromServer.bind(this);

    this.state = {
      isOpened: false,
      data: [],
      appIsMounted: false,
      isLoading: false
    };
  }

  componentDidMount() {
    this.setState({
      appIsMounted: true
    });
    this.loadHomeBannersFromServer();
  }

  loadHomeBannersFromServer() {
    this.setState({isLoading: true}, () => {
      HomeBanners.actions.list.request().then(res => {
        this.postLoadHomeBanners(res.data);
      });
    });
  }

  postLoadHomeBanners(homeBanners) {
    this.props.dispatch({
      type: 'UPDATE_HOME_BANNERS_LIST',
      homeBanners: homeBanners
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listHomeBanners !== this.state.data) {
      this.setState({isLoading: true}, () => {
        this.setState({data: nextProps.listHomeBanners}, () => {
          this.setState({isLoading: false});
        });
      });
    }
  }

  handleClickTab(e) {
    if (!this.state.isOpened) {
      document.addEventListener('click', this.handleOutsideClick.bind(this), false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
    }

    this.setState({
      isOpened: !this.state.isOpened
    });
  }

  closeOption(){
    this.setState({
      isOpened: false
    });
  }

  handleOutsideClick(e) {
    if (this.node && this.node.contains(e.target)) {
      return;
    } else if (this.node && !this.node.contains(e.target)){
      this.closeOption();
    }
  }

  render() {
    const settings = {
      className: 'slider slick-custom home-slick',
      dots: true,
      infinite: true,
      centerMode: false,
      speed: 1000,
      autoplaySpeed: 4000,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      pauseOnHover: false
    };
    return (
      <div className='all-categories home'>
        <div className='center'>
          <div className='row'>
            <HomeCategoryMenu/>
            <div className='home-tab-panel-wrap'>
              <div className="list-of-top-banner">
                <div className="item-top">
                  <div className="link">
                    <span className="wrap-icon"
                      ><img
                        className="icon"
                        src={require(`assets/images/chuong-trinh-khuyen-mai.svg`)}
                        alt="Chương trình khuyến mãi" /></span
                    ><span className="detail-item"
                      ><span className="content">Chương trình khuyến mãi</span></span
                    ><a className="mask" href="/news-category/5a4c42904867255b8e38324a"></a>
                  </div>
                </div>
                <div className="item-top">
                  <div className="link">
                    <span className="wrap-icon"
                      ><img
                        className="icon"
                        src={require(`assets/images/thong-tin-thuong-mai.svg`)}
                        alt="Thông tin thương mại" /></span
                    ><span className="detail-item"
                      ><span className="content">Thông tin thương mại</span></span
                    ><a className="mask" href="/news-category/5a04822ff75c7330ed575c09"></a>
                  </div>
                </div>
                <div className="item-top">
                  <div className="link">
                    <span className="wrap-icon"
                      ><img
                        className="icon"
                        src={require(`assets/images/danh-sach-doanh-nghiep.svg`)}
                        alt="Danh sách doanh nghiệp" /></span
                    ><span className="detail-item"
                      ><span className="content">Danh sách doanh nghiệp</span></span
                    ><a className="mask" href="/kontum-businesses"></a>
                  </div>
                </div>
              </div>

              <Slider {...settings}>
                {
                  this.state.data.map((item,i) => {
                    return(
                      <div key={i} style={{backgroundImage: `Url(${this.props.host}${this.props.uriBanner}${item.image})`}}>
                        <svg width={1030} height={650} style={{ width: '100%', maxWidth: '100%', height: 'auto', margin: '0 auto', display: 'block', opacity: '0' }}></svg>
                      </div>
                    )
                  })
                }
              </Slider>
            </div>
            <TradeNewsContainer/>
          </div>
        </div>
        <HighlightVideo/>
        <HighlightPromotions/>
      </div>
    );
  }
}

HomeBanner.defaultProps = {
  host: CONFIG.UploadImageURL,
  uriBanner: '/resize/1030x560/home-banners/download/'
}

const bindStateToProps = state => ({
  listHomeBanners: state.listHomeBanners
});

export default connect(bindStateToProps)(HomeBanner);



// WEBPACK FOOTER //
// ./components/home/sub-view/HomeBanner.jsx